import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsuarioFrontInterface } from 'src/app/core/models/auth.model';
import { IdleService } from 'src/app/core/services/idle.service';
import { globalConfig } from 'src/app/core/utils/globalConfig';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private route = inject(Router);
  private idleService = inject(IdleService);

  private sanitizer = inject(DomSanitizer);

  toastMessage: string | null = null;

  constructor() {}

  #stateIndicativo = signal<any>({
    indicativo: [],
  });

  #stateUsuario = signal<any>({
    usuario: {},
  });

  #stateTipoDocumento = signal<any>({
    tipoDocumento: [],
  });

  public indicativo = computed(() => this.#stateIndicativo().indicativo);
  public usuario: any = computed(() => this.#stateUsuario().usuario);
  public tipoDocumento: any = computed(() => this.#stateTipoDocumento().tipoDocumento);

  login(loginData: any) {
    return this.http.post('/auth/login-usuario-front', loginData);
  }

  registrarUsuarioFront(usuarioFrontData: UsuarioFrontInterface) {
    return this.http.post('/usuario-front', usuarioFrontData);
  }

  recuperarPassword(body: any) {
    return this.http.post('/usuario-front/recuperar-password', body);
  }

  setToken(token: string) {
    sessionStorage.setItem(globalConfig.tokenApi, token);
  }

  logout() {
    sessionStorage.removeItem(globalConfig.tokenApi);
    this.idleService.stopWatching();
    this.route.navigate(['/auth/sign-in']);
  }

  cambiarPasswordUsuarioFront(newPassword: string) {
    return this.http.patch('/usuario-front/nuevo-password', {
      password: newPassword,
    });
  }

  cambiarPasswordUsuarioFrontDashboard(newPassword: string, oldPassword: string = '') {
    const params = new HttpParams().set('oldPassword', oldPassword);
    return this.http.patch(`/usuario-front/nuevo-password`, {
      password: newPassword,
    }, { params });
  }

  getIndicativo() {
    this.http
      .get('/pais/indicativos')
      .pipe(
        map(({ data }: any) => {
          let filter = [];
          const { id, indicativo, nombre } = data.find((country: { nombre: string }) => country.nombre === 'Colombia');
          filter.push({
            id,
            name: `+ ${indicativo} ${nombre}`,
            indicativo,
          });
          const countriesWithoutColombia = data.filter((country: { nombre: string; }) => country.nombre !== 'Colombia')
          for (const { id, indicativo, nombre } of countriesWithoutColombia) {
            filter.push({
              id,
              name: `+ ${indicativo} ${nombre}`,
              indicativo,
            });
          }
          return filter;
        }),
      )
      .subscribe((indicativo: any) => {
        this.#stateIndicativo.set({
          indicativo,
        });
      });
  }

  getTipoDocumento() {
    this.http
      .get('/tipo-documento')
      .pipe(
        map(({ data }: any) => {
          let filter = [];
          for (const { id, nombre } of data) {
            filter.push({
              id,
              name: nombre,
            });
          }
          return filter;
        }),
      )
      .subscribe((tipoDocumento: any) => {
        this.#stateTipoDocumento.set({
          tipoDocumento,
        });
      });
  }

  loadPdf(ruta: string) {
    this.http.get(ruta, { responseType: 'blob' }).subscribe((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      return this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
    });
  }

  recuperarPasswordUsuario(newPassword: string) {
    return this.http.patch('/usuario-front/update-recuperar-password', {
      password: newPassword,
    });
  }

  actualizarPerfil(body: any) {
    return this.http.patch('/usuario-front/actualizar-perfil', body);
  }
}
